<fuse-widget class="widget p-0 h-100-p" fxLayout="column">

    <!-- Front -->
    <div class="fuse-widget-front mat-white-bg mat-elevation-z2 h-100-p" fxLayout="column" fxLayoutAlign="stretch stretch">

        <div class="px-16 py-8 border-bottom widget-header title-bar mat-accent-bg" fxLayout="row" fxLayoutAlign="space-between center">
            <div class="mat-accent-bg" fxLayout="row" fxLayoutAlign="start center">
                <div class="h3 title pr-4">{{title}}</div>
                <div *ngIf="data?.length>0" fxLayout="row" fxLayoutAlign="start center">
                    <div class="h3 secondary">({{data?.length}})</div>
                </div>
            </div>
           
            <div fxLayout="row" fxLayoutAlign="start center">
                <button mat-icon-button class="mat-icon-button" (click)="toggleSortOrder()" attr.aria-label="{{(sortedAscending === true) ? 'Sort by name descending' : 'Sort by name ascending'}}" matTooltip="{{(sortedAscending === true) ? 'Sort by name descending' : 'Sort by name ascending'}}">
                    <mat-icon  class='mat-accent-bg'>sort</mat-icon>                    
                </button>
                
                <mat-divider *ngIf="allowEdit && hasSubjectUserEditPrivs" class='style-fix' [vertical]="true"></mat-divider>

                <button *ngIf="allowEdit && hasSubjectUserEditPrivs" mat-icon-button #editmarkersbutton class="mat-icon-button" [disabled]="!allowEdit || !hasSubjectUserEditPrivs" (click)="editmarkersbutton._elementRef.nativeElement.blur();edit()" aria-label="Edit" matTooltip="Edit">
                    <mat-icon class="mat-accent-bg">edit</mat-icon>
                </button>
            </div>
        </div>

        <div *ngIf="data?.length === 0" fxLayout="column" fxLayoutAlign="center center" fxFlex>
            <span class="mat-h1 hint-text py-48">There are no markers</span>
        </div> 

        <div *ngIf="data?.length>0" class="markerlist">
            <div class="p-16 clickable row list-item" *ngFor="let row of data" (click)="select(row);" [ngClass]="{'selected':row?.id == selected?.id}">
                <div fxLayout="row" fxLayoutAlign="space-between center">
                    <div fxLayout="row" fxLayoutAlign="start center" class="w-80-p">
                        <div><mat-icon class="marker" [style.color]="row.subjectMarker?.marker?.color">room</mat-icon></div>
                        <div class="w-100-p" fxLayout="column" fxLayoutAlign="start start">
                            <div class="h3 text-truncate w-100-p">{{row.title}}</div>
                            <div class="text-truncate w-100-p">
                                <span class="secondary-text">{{row.secondary}}</span>
                            </div>
                        </div>
                    </div>
                    <div>
                        <button *ngIf="allowEdit && hasSubjectUserEditPrivs" mat-icon-button aria-label="Remove Marker" class="mat-icon-button" matTooltip="Remove Marker" (click)="delete(row);">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </div>  
                </div>
            </div>
        </div>
    </div>


    <!-- / Front -->

</fuse-widget>